import { Picture } from '@/components/image/Image';
import { useModal } from '@/components/modal/useModal';
import { cn } from '@/lib/utils';
import { ImageDetails } from '@/services/api/contracts/catalog/types';
import { FC } from 'react';
import Balancer from 'react-wrap-balancer';
import { InputContainer } from '../InputContainer';
import { UploadIcon } from '../file/shared';
import { InputProps, withField } from '../withField';
import { GalleryModal } from './GalleryModal';

interface GalleryInputProps {
  placeholder?: string;
}

export const GalleryInput: FC<InputProps<ImageDetails | undefined> & GalleryInputProps> = ({
  onChange,
  value,
  placeholder
}) => {
  const galleryModalProps = useModal();
  return (
    <>
      <GalleryModal {...galleryModalProps} onSelect={onChange} />
      <InputContainer
        aria-role="button"
        onClick={() => galleryModalProps.open()}
        className="hover:bg-primary-std z-20 flex w-full cursor-pointer flex-col items-center justify-center overflow-clip p-[1px]"
      >
        {value?.id ? (
          <Picture className="rounded-lg overflow-clip" image={value} containerHeight={200} containerWidth={200} />
        ) : (
          <div
            className={cn(
              'pointer-events-none relative flex w-full items-center justify-center gap-4 rounded-lg py-4 text-[#DADADA]'
            )}
          >
            <UploadIcon />
            <p className="text-secondary-std w-28 text-sm leading-tight">
              <Balancer>{placeholder}</Balancer>
            </p>
          </div>
        )}
      </InputContainer>
    </>
  );
};

export const GalleryField = withField<ImageDetails | undefined, GalleryInputProps>(GalleryInput);
